import classnames from "classnames"
import { TimelineBodyProps } from "./types"

/**
 * Holds additional content for the milestone
 * Accepts any React node, allowing rich content like text, images, cards, or interactive elements
 *
 * @component
 * @example
 * <Timeline.Body>
 *   <p>Custom body</p>
 * </Timeline.Body>
 */
export const TimelineBody = ({ className, children, ...rest }: TimelineBodyProps) => {
  return (
    <section {...rest} className={classnames(className)}>
      {children}
    </section>
  )
}

TimelineBody.displayName = "TimelineBody"
